import { Template } from './Template'

export { Template as EmbroideryCartItem }
